import { create } from "zustand";

// Dark mode is forced app-wide — there is no light theme and no toggle. The
// store keeps a minimal shape for the few consumers that read `resolved`
// (e.g. AG Grid theme selection in PaperTable); it is always "dark".
type Resolved = "dark";

interface ThemeState {
  resolved: Resolved;
}

// Ensure the `.dark` class is present even if the index.html boot script was
// stripped or ran in an unusual environment (tests, SSR-less hydration).
if (typeof document !== "undefined") {
  document.documentElement.classList.add("dark");
}

export const useThemeStore = create<ThemeState>(() => ({
  resolved: "dark",
}));
